import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const PowerSupplies = lazy(() => import('../pages/pages/PowerSupplies'))
const PowerSupply = lazy(() => import('../pages/pages/PowerSupply'))

export default [
  {
    path: '/powersupplies',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <PowerSupplies />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/powersupplies/:id',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <PowerSupply />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
